import {Apps} from "../enums";
import {AvailableApp} from "services";

enum LocalStorageKeys {
    JWT = 'tokenator',
    SupportUserKey = 'supportUserKey',
    Refresh = 'refrigirator',
    UserId = 'my',
    App = 'app',
    IsTest = 'isTest',
    AvailableApps = 'availableApps'
}

export const storage = {
    getAvailableApps: () => {
        const apps = localStorage.getItem(LocalStorageKeys.AvailableApps);
        return apps ? JSON.parse(apps) as AvailableApp[] : undefined
    },
    setAvailableApps: (apps: AvailableApp[]) => {
        localStorage.setItem(LocalStorageKeys.AvailableApps, JSON.stringify(apps))
    },
    getToken: () => {
        return localStorage.getItem(LocalStorageKeys.JWT);
    },
    setToken: (token: string) => {
        return localStorage.setItem(LocalStorageKeys.JWT, token);
    },
    setSupportUserKey: (token?: string) => {
        if (!token) {
            localStorage.removeItem(LocalStorageKeys.SupportUserKey)
            return
        }
        return localStorage.setItem(LocalStorageKeys.SupportUserKey, token);
    },
    getSupportUserKey: () => {
        return localStorage.getItem(LocalStorageKeys.SupportUserKey);
    },
    getUserId: () => {
        return localStorage.getItem(LocalStorageKeys.UserId);
    },
    getIsTest: () => {
        return !!localStorage.getItem(LocalStorageKeys.IsTest);
    },
    setUserId: (id: string) => {
        return localStorage.setItem(LocalStorageKeys.UserId, id);
    },
    getRefresh: () => {
        return localStorage.getItem(LocalStorageKeys.Refresh);
    },
    setRefresh: (token: string) => {
        return localStorage.setItem(LocalStorageKeys.Refresh, token);
    },
    getApp: () => {
        return localStorage.getItem(LocalStorageKeys.App) as Apps;
    },
    setApp: (id: Apps) => {
        return localStorage.setItem(LocalStorageKeys.App, id);
    },
    setIsTest: (isTest: boolean) => {
        if (isTest) {
            localStorage.setItem(LocalStorageKeys.IsTest, 'true')
        } else {
            localStorage.removeItem(LocalStorageKeys.IsTest)
        }
    },
    clearAll: () => {
        localStorage.clear();
    }
}